import Vue from 'vue'
import Router from 'vue-router'

const h5index = () => import('@/components/index')

const login = () => import('@/components/Login/login')

const location = () => import('@/components/location/location')

// 我的
const mine = () => import('@/components/mine/mine')
const buyer = () => import('@/components/mine/buyer/buyer')
const seller = () => import('@/components/mine/seller/seller')
const order = () => import('@/components/mine/order/order')
const orderDetail = () => import('@/components/mine/order/orderDetail')
const refund = () => import('@/components/mine/refund/refund')
const collect = () => import('@/components/mine/collect/collect')
const collectList = () => import('@/components/mine/collect/collectList')
const coupons = () => import('@/components/mine/coupons/coupons')
const center = () => import('@/components/mine/coupons/couponsCenter')

// 短租
const shortRent = () => import('@/components/service/list/short/shortRent') // 短租列表
const shortRentDetail = () => import('@/components/service/list/short/detail/shortRentDel') // 短租详情
const book = () => import('@/components/service/book/book')
const pay = () => import('@/components/service/pay/pay')

// 写字楼出租
const longRent = () => import('@/components/service/list/long/rent/longRent') // 写字楼出租列表
const longRentDetail = () => import('@/components/service/list/long/rent/detail/longRentDetail') // 写字楼出租详情

// 房源出租详情
const longRentHouse = () => import('@/components/service/list/long/rent/detail/longRentHouse')

// 写字楼出售
const longSale = () => import('@/components/service/list/long/sale/longSale') // 写字楼出售列表
const longSaleDetail = () => import('@/components/service/list/long/sale/detail/longSaleDetail') // 写字楼出售详情

const buildingDetail = () => import('@/components/service/list/long/building/buildingDetail.vue') // 楼盘详情

// 设计类列表
const designList = () => import('@/components/service/list/design/designList')

// 房源出售详情
const longSaleHouse = () => import('@/components/service/list/long/sale/detail/longSaleHouse')

// 需求详情
const requireDetail = () => import('@/components/service/require/list/requireDetail')

// 需求列表
const requireList = () => import('@/components/service/require/list/requireList')

// 设计类详情
const designDetail = () => import('@/components/service/list/design/detail/designDetail')

const about = () => import('@/components/info/about')
const sale = () => import('@/components/info/sale')
const service = () => import('@/components/info/service')

// 引导页
const guidance = () => import('@/components/guidance/guidance')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: h5index
    },
    {
      path: '/demo',
      name: '111',
      component: () => import('@/components/HelloWorld.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@//components/test')
    },
    {
      path: '/guidance',
      name: '引导下载APP页',
      component: guidance
    },
    {
      path: '/mine',
      component: mine,
      children: [{
        path: '/mine/buyer',
        component: buyer
      }, {
        path: '/mine/seller',
        component: seller
      }]
    },
    {
      path: '/mine/:identy/order/list',
      component: order // 订单列表
    },
    {
      path: '/service/shorts/buyer/orders/detail/:orderNum',
      component: orderDetail // 订单详情
    },
    {
      path: '/mine/:identy/order/list/refund',
      component: refund // 售后退款列表
    },
    {
      path: '/mine/collection',
      component: collect // 我的收藏
    },
    {
      path: '/mine/collection/:type/list',
      component: collectList // 收藏列表
    },
    {
      path: '/mine/coupons',
      component: coupons // 我的券包
    },
    {
      path: '/mine/coupons/center',
      component: center // 领券中心
    },
    {
      path: '/about',
      component: about
    },
    {
      path: '/sale',
      component: sale
    },
    {
      path: '/service',
      name: '17度平台服务协议',
      component: service
    },
    {
      path: '/service/shorts/:type',
      component: shortRent // 短租列表
    },
    {
      path: '/service/shorts/:type/detail/:id',
      component: shortRentDetail // 短租详情
    },
    {
      path: '/service/shorts/pay/:type/:orderNum',
      component: book // 创建短租订单
    },
    {
      path: '/service/shorts/pay/:orderNum',
      component: pay // 支付
    },
    {
      path: '/service/buildings/rent',
      component: longRent // 写字楼出租列表
    },
    {
      path: '/service/buildings/rent/detail/:id',
      component: longRentDetail // 写字楼出租详情
    },
    {
      path: '/service/buildings/detail/:id',
      component: buildingDetail // 楼盘详情
    },
    {
      path: '/service/buildings/rent/:bid/house/:hid',
      component: longRentHouse // 房源出租详情
    },
    {
      path: '/service/buildings/sale',
      component: longSale // 写字楼出售列表
    },
    {
      path: '/service/buildings/sale/detail/:id',
      component: longSaleDetail // 写字楼出售详情
    },
    {
      path: '/service/buildings/sale/:bid/house/:hid',
      component: longSaleHouse // 房源出售详情
    },
    {
      path: '/service/require/:id/detail',
      component: requireDetail // 需求详情
    },
    {
      path: '/service/require/:type/list',
      component: requireList // 需求列表
    },
    {
      path: '/services/:servicesType/:type',
      component: designList // 设计类列表
    },
    {
      path: '/services/:item/detail/:type/:id', // 详情
      component: designDetail // 设计类详情
    },
    {
      path: '/login',
      component: login // 登录
    },
    {
      path: '/location',
      component: location // 定位
    },
    {
      path: '/rank',
      component: () => import('../components/rank/rank.vue') // 设计师打榜
    },
    {
      path: '/store/:type/:id', // 商铺出租出售详情
      component: () => import('../components/service/list/store/detail/detail.vue')
    },
    {
      path: '/depot/:type/:id', // 厂房出租出售详情
      component: () => import('../components/service/list/depot/detail/detail.vue')
    },
    {
      path: '/land/:type/:id', // 厂房出租出售详情
      component: () => import('../components/service/list/land/detail/detail.vue')
    },
    {
      path: '/help/short',
      name: '短租协议',
      component: () => import('../components/info/short.vue')
    },
    {
      path: '/help/userservice',
      name: '17度平台用户服务协议',
      component: () => import('../components/info/userservice.vue')
    },
    {
      path: '/help/long',
      name: '长租协议',
      component: () => import('../components/info/long.vue')
    },
    {
      path: '/help/decoration',
      name: '装修服务协议',
      component: () => import('../components/info/decoration.vue')
    },
    {
      path: '/help/conceal',
      name: '隐私保护声明',
      component: () => import('../components/info/conceal.vue')
    },
    {
      path: '/help/copyright',
      name: '版权声明',
      component: () => import('../components/info/copyright.vue')
    },
    {
      path: '/help/relief',
      name: '免责声明',
      component: () => import('../components/info/relief.vue')
    },
    {
      path: '/help/knowledge',
      name: '知识产权说明',
      component: () => import('../components/info/knowledge.vue')
    },
    {
      path: '/help/deposit',
      name: '17度平台类目保证金规则',
      component: () => import('../components/info/deposit.vue')
    },
    {
      path: '/help/invoice',
      name: '17度平台发票开具规则',
      component: () => import('../components/info/invoice.vue')
    },
    {
      path: '/help/promise',
      name: '17度平台服务承诺保障与诚信保证金使用规则',
      component: () => import('../components/info/promise.vue')
    },
    {
      path: '/help/publish',
      name: '17度平台服务发布与处理规则',
      component: () => import('../components/info/publish.vue')
    },
    {
      path: '/help/join',
      name: '17度平台商家入驻协议',
      component: () => import('../components/info/join.vue')
    },
    {
      path: '/help/require',
      name: '17度平台需求发布与处理规则',
      component: () => import('../components/info/requirepublish.vue')
    },
    {
      path: '/help/cost',
      name: '17度平台技术服务费收费标准',
      component: () => import('../components/info/cost.vue')
    },
    {
      path: '/help/argue',
      name: '17度平台举报和争议纠纷处理规则',
      component: () => import('../components/info/argue.vue')
    },
    {
      path: '/help/prodeposit',
      name: '17度平台服务类项目保证金托管协议',
      component: () => import('../components/info/prodeposit.vue')
    },
    {
      path: '/help/buildingPublish',
      name: '17度房源发布和处理标准',
      component: () => import('../components/info/buildingPub.vue')
    },
    {
      path: '/help/refundrules',
      name: '退订规则',
      component: () => import('../components/info/refundrules.vue')
    },
    {
      path: '/help/sopl',
      name: '17度平台商家管理规范',
      component: () => import('../components/info/sopl.vue')
    },
    {
      path: '/help/transactionRules',
      name: '17度平台交易规则',
      component: () => import('../components/info/transactionRules.vue')
    },
    {
      path: '/industrialpark',
      name: '17度产业园',
      component: () => import('../components/industrialPark/industrialPark.vue')
    },
    {
      path: '/feepays',
      name: '费用缴纳说明',
      component: () => import('../components/info/feePays.vue')
    },
    {
      path: '/joinus',
      name: '服务商入驻',
      component: () => import('../components/joinus/joinus.vue')
    },
    {
      path: '/cooperation',
      name: '经纪商合作',
      component: () => import('../components/broker/broker.vue')
    },
    {
      path: '/partnership',
      name: '合伙人协议',
      component: () => import('../components/info/partnership.vue')
    },
    {
      path: '/award',
      name: '奖励规则',
      component: () => import('../components/info/award.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js